import React, { useState } from 'react';
import { Button } from './ui/Button';
import { User, Lock, ArrowRight, AlertCircle } from 'lucide-react';
export function LoginForm() {
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login
    setTimeout(() => setIsLoading(false), 1500);
  };
  return <div className="bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-gray-100 w-full max-w-md mx-auto relative z-10" data-id="element-227">
      <div className="text-center mb-6" data-id="element-228">
        <h3 className="text-xl font-bold text-gray-900" data-id="element-229">
          Student Log In for On-Demand Classes
        </h3>
        <p className="text-sm text-gray-500 mt-1" data-id="element-230">
          Access your on-demand classes and certificates
        </p>
      </div>

      <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2" data-id="element-231">
        <AlertCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-232" />
        <p className="text-sm text-blue-900" data-id="element-233">
          <strong data-id="element-234">Note:</strong> This log in is for On-Demand Classes only. Zoom
          class students do not need to register here.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-235">
        <div data-id="element-236">
          <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-237">
            Username
          </label>
          <div className="relative" data-id="element-238">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-239">
              <User className="h-5 w-5 text-gray-400" data-id="element-240" />
            </div>
            <input type="text" id="username" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-brand-purple-500 focus:border-brand-purple-500 transition-colors" placeholder="Enter your username" required data-id="element-241" />
          </div>
        </div>

        <div data-id="element-242">
          <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-243">
            Password
          </label>
          <div className="relative" data-id="element-244">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-245">
              <Lock className="h-5 w-5 text-gray-400" data-id="element-246" />
            </div>
            <input type="password" id="password" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-brand-purple-500 focus:border-brand-purple-500 transition-colors" placeholder="••••••••" required data-id="element-247" />
          </div>
        </div>

        <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-248">
          Log In <ArrowRight className="ml-2 h-4 w-4" data-id="element-249" />
        </Button>
      </form>

      <div className="mt-6 space-y-3 text-center" data-id="element-250">
        <div className="text-sm" data-id="element-251">
          <span className="text-gray-500" data-id="element-252">New student? </span>
          <a href="/login-register" className="font-medium text-brand-purple-700 hover:text-brand-purple-800 hover:underline" data-id="element-253">
            Create an account
          </a>
        </div>
        <div data-id="element-254">
          <a href="/14.html" className="text-sm text-gray-500 hover:text-gray-700 hover:underline" data-id="element-255">
            Forgot your password?
          </a>
        </div>
      </div>
    </div>;
}